module.exports = __webpack_public_path__ + "common/tp-featured3-2bb198f6059fbc195928fe60a35282cc.svg";